import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraOutPatientSupportSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M32.225 0.216064C27.8073 0.216064 23.5212 0.973625 19.4855 2.46725C9.87754 6.02867 3.12272 13.9243 0.952482 24.1292C-0.481698 30.7828 -0.298315 36.9369 1.51654 42.9342C3.83349 50.5932 9.52089 57.0521 17.1205 60.654C20.8932 62.4461 25.2273 63.4693 30.0003 63.6944C30.6137 63.7222 31.2372 63.7374 31.8569 63.7374C35.6865 63.7374 39.5388 63.2125 43.3076 62.178C43.5972 62.1059 43.8729 62.0313 44.1638 61.9453C47.5507 60.9537 50.5987 59.3855 53.2065 57.2899C56.0382 55.0273 58.369 52.159 60.127 48.7695C60.4735 48.1018 60.8049 47.3986 61.1704 46.5576C63.1813 41.8883 64.1525 36.6612 63.9805 31.4354C63.8996 29.1248 63.5556 26.6687 62.9612 24.1292C61.9823 20.0088 60.3862 16.1337 58.345 12.9163C57.786 12.0525 57.2725 11.3265 56.7641 10.6739C53.0952 5.94141 47.3787 2.62028 40.2382 1.0748C37.6151 0.505683 34.9188 0.217329 32.2262 0.217329L32.225 0.216064Z'
        fill='white'
        fillOpacity='0.4'
      />
      <Path
        d='M27.3392 15.713C27.3392 15.713 38.7817 13.0305 39.8704 13.158C40.8754 13.2755 41.5904 13.553 42.4154 15.9492C43.2104 18.258 48.6467 41.5292 48.6567 41.5842C49.2342 44.773 47.7767 45.0805 46.3942 45.6317C45.0279 46.178 29.7767 49.7567 25.7167 50.7005C24.6529 50.948 23.4892 50.9805 22.5917 50.673C21.8817 50.4292 21.1217 50.228 20.3092 47.6205C19.2754 44.3055 14.6267 22.2092 14.6267 22.2092C14.6267 22.2092 14.1279 19.4892 16.8517 18.6655C19.5742 17.8417 27.3379 15.713 27.3379 15.713H27.3392Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M27.888 17.8916C27.888 17.8916 37.8055 15.5666 38.748 15.6766C39.6192 15.7779 40.238 16.0179 40.9542 18.0966C41.643 20.0979 46.3542 40.2654 46.363 40.3129C46.863 43.0766 45.6005 43.3429 44.403 43.8204C43.2192 44.2929 30.0017 47.3954 26.483 48.2129C25.5617 48.4266 24.553 48.4554 23.7755 48.1891C23.1592 47.9779 22.5017 47.8041 21.7967 45.5429C20.9017 42.6704 16.8717 23.5204 16.8717 23.5204C16.8717 23.5204 16.4405 21.1629 18.7992 20.4491C21.1592 19.7354 27.888 17.8904 27.888 17.8904V17.8916Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M24.2928 15.9542C24.2928 15.9542 20.2278 16.6092 20.2878 17.8654C20.3465 19.1204 20.3728 21.0467 22.3965 20.8867C24.4203 20.7267 35.4928 17.9829 36.1665 17.3229C36.8415 16.6617 36.3053 13.6454 35.2303 13.4654C34.1553 13.2854 31.1115 14.3004 31.1115 14.3004C31.1115 14.3004 29.7978 11.7479 27.2415 12.5342C24.6853 13.3204 24.294 15.9554 24.294 15.9554L24.2928 15.9542Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M48.7623 21.7422L45.8848 19.3123L32.9914 34.5803L35.8689 37.0102L48.7623 21.7422Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M48.8005 17.8163L49.7469 18.6156C50.2798 19.0656 50.3471 19.8636 49.8971 20.3965L48.7599 21.743L45.8825 19.3131L47.0196 17.9665C47.4696 17.4336 48.2676 17.3663 48.8005 17.8163Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M32.9935 34.5791L32.001 38.6741L35.871 37.0091L32.9935 34.5791Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
